<span class="d-flex small position-absolute top-100 start-0 role-badge-wrapper">
    <span *ngFor="let role of badges" [title]="role"
        data-bs-toggle="tooltip"
        class="me-1 bg-danger rounded-pill badge border border-light">{{ role[0] }}</span>
</span>